import { Expose } from 'class-transformer';
import { EmailRequestBaseEntity } from './base.entity';
import { UserEntity } from './user.entity';

export class AuthRegisterResponse extends EmailRequestBaseEntity {
  @Expose()
  public user: UserEntity;
}
